import React from 'react';
import TemplateFooter from './TemplateFooter';

class Report_RP08 extends React.PureComponent  {

    constructor(props) {
        super(props);
        this.state = {
            rowGroup : {}
        }

        this.collapse = this.collapse.bind(this);
    }
    collapse(evt) {
    
        const rowId = evt.currentTarget.getAttribute('rowgroup');
        const rowSet = {
            rowGroup: {
                ...this.state.rowGroup,
                [rowId]: this.state.rowGroup[rowId] ? false : true
            }
        }
        this.setState({
            ...rowSet
        });
    }

    render () {

        const {ReportHeader, ReportFooter, ReportNotes} = this.props;
        const reportData = Array.isArray(this.props.reportResults) && this.props.reportResults.length ? this.props.reportResults[0] : {};

        const dataKeys = Object.keys(reportData);

        return <React.Fragment>
            <div  className="print-template">
                { ReportHeader }
                <div className="report-body">

                    <table className="default">
                        <thead>
                            <tr>
                                <th>Bills</th>
                                <th className="number">Paid</th>
                                <th className="number">Balance</th>
                                <th className="number">Due Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                        { dataKeys.map((key, g) => {
                            
                            const add = (accumulator, item) => {
                                return accumulator + (item.amountDue || item);
                            }
                            var sum = reportData[key].reduce(add, 0);

                            var rowGroup = [<tr key={g} onClick={this.collapse} className={`collapsible-row ${this.state.rowGroup[g] ? '--folded' : ''}`} rowgroup={g}>
                            
                            <td>{key} - {reportData[key][0].account.clientInfo.firstName} {reportData[key][0].account.clientInfo.lastName} </td>
                            <td></td>
                            <td></td>
                            <td className="number">${sum.toCurrency()}</td>
                            </tr>]

                            reportData[key].map((bill, i) => {
                                rowGroup.push(<tr key={bill.id}  className={`smpl-row row-divider no-padding ${this.state.rowGroup[g] ? '--hide' : ''}`} groupid={g}>
                                <td className="">
                                    <span className="l bold">Ref# {bill.referenceNo}</span>
                                    <span className="l">{bill.status}</span>
                                    <span className="l"><small>{bill.dueDate}</small></span>
                                </td>
                                <td className="number">${bill.amountPaid.toCurrency()}</td>
                                <td className="number">${(bill.amountDue - bill.amountPaid).toCurrency()}</td>
                                <td className="number">${bill.amountDue.toCurrency()}</td>
                                </tr>)
                            });

                            return rowGroup;
                            })}
                        </tbody>
                    </table>
                </div>
                { <TemplateFooter 
                    ReportFooter={ReportFooter}  
                    ReportNotes={ReportNotes}
                    /> 
                }
            </div>
           
        </React.Fragment> 
    }  
}

export default Report_RP08;